// header.component.ts
import { HttpClient } from '@angular/common/http';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, debounceTime, delay, map, switchMap } from 'rxjs/operators';
import { DataService } from 'src/app/pages/data.service';
import { urls } from 'src/app/pages/urls';

@Component({
  selector: 'app-product-header',
  templateUrl: './product-header.component.html',
  styleUrls: ['./product-header.component.scss']
})
export class ProductHeaderComponent implements OnInit {
  @Output() brandFilterChange = new EventEmitter<string>();
  @Output() openFilterChange = new EventEmitter<string>();
  @Output() searchFilterChange = new EventEmitter<string>();


  brandCtrl = new FormControl();
  enCtrl = new FormControl();
  categoryAuto: any;
  brandAuto: any;
  openAuto: any;
  categoryOptions: string[] = ['Category 1', 'Category 2', 'Category 3'];


  searchControl = new FormControl();
  categories: any[] = [];
  username: string
  countryName: string


  constructor(private dataService: DataService, private http: HttpClient, private service: DataService, private router: Router) { }
  filteredCategories: any[] = []; // Store the filtered categories here

  brandList: any[] = [];
  openList: any[] = [];
  searchBrandControl: FormControl = new FormControl();

  searchOpenControl = new FormControl();

  filteredBrands: any = []
  filteredOpen: any = []
  searchcatString: string = '';
  searchcatKey: string = '';
  searchString: string = '';

  searchOpenString: string = '';
  searchCategoryID: any;
  searchBrandID: any;



  ngOnInit() {
    this.username = this.service.getEmail().split(".")[0].toUpperCase();
    this.countryName = localStorage.getItem('selectedCountryName');

    this.setupAutoBrandcomplete();
    this.setupAutoOpencomplete();
  }

  setupAutoBrandcomplete() {
    this.searchBrandControl.valueChanges
      .pipe(
        debounceTime(300),
        switchMap(value => {
          if (value && value.length >= 3) {
            this.searchString = value;
            return this.fetchBrands(value);
          } else {
            return []; // Return an empty array if the value is empty or less than 3 characters
          }
        })
      )
      .subscribe((brands: any[]) => {
        this.filteredBrands = brands;

      });
  }



  fetchBrands(brandSearch: string): Observable<any[]> {
    // ... your existing code to fetch brands from the API ...
    const countryCode = this.dataService.getSelectedCountryCode();
    const apiUrl = `https://catalogueapi.moglix.com/search/brands`;
    let brandSearchAry = [];
    brandSearchAry.push(brandSearch);
    const requestBrand = {
      "searchString": brandSearchAry,
      "havingPdf": false,
      "havingLatestPdf": false,
      "countryCode": this.dataService.getSelectedCountryCode()
    };
    return this.http.post(apiUrl, requestBrand).pipe(
      map((response1: any) => {
        const data1 = response1 && response1.data ? response1.data : {};
        let keystr = Object.keys(data1['brandSearchResponse'])
        this.brandList = data1['brandSearchResponse'][keystr[0]]
        return this.brandList
      })
    );
  }


  onBrandFilterChange(brandFilterValue: any) {
    this.searchBrandControl.setValue(brandFilterValue.brandName);
    this.searchBrandID = brandFilterValue.brandId;
    this.brandFilterChange.emit(brandFilterValue.brandId);
  }


  setupAutoOpencomplete() {
    this.searchOpenControl.valueChanges
      .subscribe((openString: string) => {
        this.searchOpenString = openString;
      });
  }

  onOpenFilterChange(openFilterValue: string) {
    this.searchOpenControl.setValue(openFilterValue);
    this.searchOpenString = openFilterValue;
    // Emit the value to the parent component
    this.openFilterChange.emit(openFilterValue);
  }

  onSearchFilterChange(searchFilterChange: string) {


    searchFilterChange = '/product-discovery'
    this.searchFilterChange.emit(searchFilterChange);
    const apiUrl = urls.search + `search/view/products?pageNo=0&pageSize=20`;
    
    const requestOpen = {
      "productSearchString": this.searchOpenString != null ? this.searchOpenString : null,
      "categoryCode": this.searchCategoryID != null ? this.searchCategoryID : null,
      "brandId": this.searchBrandID != null ? this.searchBrandID : null,
      "countryName": this.dataService.getSelectedCountryName().toLowerCase()
    }

    this.dataService.eventTracker("CIS-PORTAL","Product-Discovery",JSON.stringify(requestOpen),"/product-discovery");
    return this.http.post(apiUrl, requestOpen).subscribe(data => {
      this.dataService.offSpinner()

    });
    this.router.navigateByUrl(searchFilterChange);
  }



  logout() {
    this.service.destorySession();
    this.router.navigateByUrl('/login')
      .then(() => {
        window.localStorage.setItem('logged_in', 'false');

      });
  }
}
